import React from 'react';
import PropTypes from 'prop-types';

import { getAlbumMembershipGroupPreviewMatchedPhotoUrl } from '../../helpers';
import HeadOpenGraphMeta from '../../../../../../../components/global/HeadOpenGraphMeta';
import { getAsset } from '../../../../../../../util/assets';

const propTypes = {
  albumMembershipGroup: PropTypes.shape({
    id: PropTypes.string.isRequired,
    matched_photos_extended: PropTypes.shape({
      records: PropTypes.array.isRequired,
    }).isRequired,
  }).isRequired,
};

const MatchesHeadMeta = ({ albumMembershipGroup }) => {
  const previewMatchedPhotoUrl =
    getAlbumMembershipGroupPreviewMatchedPhotoUrl(albumMembershipGroup);
  const fallback = getAsset('/og-link-preview-fallback-matches.png');

  return (
    <HeadOpenGraphMeta
      title={albumMembershipGroup?.display_name ?? ''}
      imageUrl={previewMatchedPhotoUrl || fallback}
    />
  );
};

MatchesHeadMeta.propTypes = propTypes;

export default MatchesHeadMeta;
